// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HuIb","label":"styles_label__11a7a"};